import { render } from "./soldierAgreement.vue?vue&type=template&id=1a1f2414"
import script from "./soldierAgreement.vue?vue&type=script&lang=js"
export * from "./soldierAgreement.vue?vue&type=script&lang=js"

import "./soldierAgreement.vue?vue&type=style&index=0&id=1a1f2414&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__